<template>
  <v-card class="card pa-6 mx-auto" elevation="2">
    <div class="py-6 d-flex align-center">
      <v-img height="45px" contain src="~@/assets/logo-imprimax.svg"></v-img>
    </div>
    <div class="py-6 my-6 mx-2 px-1 d-flex flex-column justify-center align-center">
      <span class="label py-2">
        {{ textMessage }}
      </span>
      <span class="label observation py-6">
        {{ textObservation1 }}
      </span>
      <span class="label observation py-">
        {{ textObservation2 }}
      </span>
    </div>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn
            elevation="4"
            large
            style="max-width: fit-content"
            class="white--text"
            @click="submit(false), close()"
            :loading="loading"
          >
            <span>{{ cancelBtn }}</span>
          </v-btn>
          <v-btn
            elevation="4"
            large
            style="max-width: fit-content"
            class="okBtn white--text"
            @click="submit(true), close()"
            :loading="loading"
          >
            <span>{{ okbtn }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.card {
  background: #ffffff !important;
  height: 525px;
  border: 1px solid #dadada;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 7px !important;
}

.okBtn {
  font-weight: bold !important;
  box-sizing: border-box !important;
  background: #bc0000 !important;
  width: 363px;
  border-radius: 8px solid #2d3038 !important;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 29px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #bc0000;
}

.observation {
  font-family: Roboto;
  font-style: normal;
  color: grey;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import {findLatitudeAndLongitude} from "../../../../services/GoogleMaps";

export default {
  name: "ConfirmModalAdd",

  props: {
    filter: Object,
    resale: Object,
    textMessage: String,
    okbtn: String,
    cancelBtn: String,
    textObservation1: String,
    textObservation2: String,
  },

  data: () => ({
    isEditing: false,
    resaleModified: [],
    location: [],
    loading: false,
    excelDialog: "",
    apiService: new ApiService(),
  }),
  async created() {
    if (this.$route.query.id) {
      this.isEditing = true;
    }
    const {lat,lng} = await findLatitudeAndLongitude(this.resale);
    this.resale.latitude = lat ? parseFloat(lat) : null;
    this.resale.longitude = lng ? parseFloat(lng) : null;
  },
  methods: {
    close() {
      this.$emit("close");
    },

    goTo(rota) {
      this.$router.push("/" + rota);
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },

    async submit(active) {
      const resaleModified = {
        Id: this.resale.id,
        Name: this.resale.name,
        Password: this.generatePassword(),
        Cnpj: this.resale.cnpj,
        InscrEstadual: this.resale.inscrEstadual,
        NameFantasy: this.resale.nameFantasy,
        PhoneNumber: this.resale.phoneNumber,
        PhoneNumber2: this.resale.phoneNumber2,
        Email: this.resale.email,
        Country: this.resale.country,
        BirthDate: this.resale.birthDate ? this.resale.birthDate : null,
        AddressNumber: parseInt(this.resale.addressNumber),
        PostalCode: this.resale.postalCode,
        Neighborhood: this.resale.neighborhood,
        AddressName: this.resale.addressName,
        State: this.resale.state,
        AddressComplement: this.resale.addressComplement,
        City: this.resale.city,
        /*ReceiveEmail: false,*/
        ReceiveSms: false,
        Region: this.resale.region,
        Category: this.resale.category,
        Observations: this.resale.textObservation,
        ReceiveEmail: true,
        AccountNumber: "",
        AgencyNumber: "",
        AccountBank: "",
        AccountType: "",
        /*AccountNumber: this.resale.accountNumber,
        AgencyNumber: this.resale.agencyNumber,
        AccountBank: this.resale.accountBank,
        AccountType: this.resale.accountType,*/
        Status: active ? 1 : 0,
        Latitude: this.resale.latitude,
        Longitude: this.resale.longitude,

        NameReceiver: this.resale.nameReceiver,
        EMailReceiver: this.resale.eMailReceiver,
        Description: this.resale.description,
        Document: this.resale.document,
        TypeReceiver: this.resale.typeReceiver,
        CodeReceiver: this.resale.codeReceiver,
        HolderName: this.resale.holderName,
        Bank: this.resale.bank,
        BranchMumber: this.resale.branchMumber,
        BranchCheckDigit: this.resale.branchCheckDigit,
        AccountNumberReceiver: this.resale.accountNumberReceiver,
        AccountCheckDigit: this.resale.accountCheckDigit,
        HolderYype: this.resale.document.length === 11 ? 'individual' : 'company',
        HolderDocument: this.resale.document,
        TransferEnabled: false,
        TransferInterval: this.resale.transferInterval,
        TransferDay: this.resale.transferDay,
        GatewayRecipientsStatus: this.resale.gatewayRecipientsStatus,
        AccountTypeReceiver: this.resale.accountTypeReceiver,
        percentagePaidToPlatform: this.resale.percentagePaidToPlatform,
        individualName: this.resale.individualName,
        typePersonReceiver: this.resale.typePersonReceiver,
        individualBirthdate: this.resale.individualBirthdate,
        annualRevenue: this.resale.annualRevenue,
        individualMonthlyIncome: this.resale.individualMonthlyIncome,
        individualProfessionalOccupation: this.resale.individualProfessionalOccupation,
        managingPartnersName: this.resale.managingPartnersName,
        managingPartnersEmail: this.resale.managingPartnersEmail,
        managingPartnersDocument: this.resale.managingPartnersDocument,
        managingPartnersBirthdate: this.resale.managingPartnersBirthdate,
        managingPartnersMonthlyIncome: this.resale.managingPartnersMonthlyIncome,
        managingPartnersProfessionalOccupation: this.resale.managingPartnersProfessionalOccupation,
        managingPartnersSelfDeclaredLegalRepresentative: this.resale.managingPartnersSelfDeclaredLegalRepresentative,
        managingPartnersAddressStreet: this.resale.managingPartnersAddressStreet,
        managingPartnersAddressComplementary: this.resale.managingPartnersAddressComplementary,
        managingPartnersAddressStreetNumber: this.resale.managingPartnersAddressStreetNumber,
        managingPartnersAddressNeighborhood: this.resale.managingPartnersAddressNeighborhood,
        managingPartnersAddressCity: this.resale.managingPartnersAddressCity,
        managingPartnersState: this.resale.managingPartnersState,
        managingPartnersZipCode: this.resale.managingPartnersZipCode,
        managingPartnersReferencePoint: this.resale.managingPartnersAddressComplementary,
        managingPartnersPhone: this.resale.managingPartnersPhone,
        companyNameReceiver: this.resale.companyNameReceiver,
        tradingNameReceiver: this.resale.tradingNameReceiver,
    };
      console.log('resaleModified')
      console.log(resaleModified)
      console.log('resaleModified')
      let url = "resale/add";
      let messageError = `Não foi possível cadastrar a revenda!`
      if (this.isEditing) {
        url = "resale/edit";
        messageError = `Não foi possível editar a revenda!`
      }

      await this.apiService
        .post(url, resaleModified)
        .then((resp) => {
          /*let email = {
            Url: process.env.VUE_APP_BASE_URL_FRONT,
            Name: resaleModified.Name,
            To: resaleModified.Email,
            Subject: "Senha provisória IMPRIMAX Autoadesivos",
            Message: resaleModified.Password,
            Type: "revendedor",
          };
          if (this.isEditing) {
             email = {
              Url: process.env.VUE_APP_BASE_URL_FRONT,
              Name: resaleModified.Name,
              To: resaleModified.Email,
              Subject: "IMPRIMAX - Alteração de cadastro",
              Message: `Olá, seu cadastro foi alterado recentemente.
                .Para acessar a alteração de dados, vá até a pagina de configuracões, que se encontra no seu menu de usuario no canto superior direito!`,
            };
          }
          this.sendEmailResale(email);*/
          console.log('resp')
          console.log(resp)
          console.log('resp')
          if (this.isEditing) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Cadastro atualizado com sucesso!",
              message: "Dados foram atualizados",
              trace: null,
            });
          } else {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Cadastro efetuado com sucesso!",
              message: "Bem vindo à IMPRIMAX!",
              trace: null,
            });
          }
          let token = localStorage.getItem("token");
          if (token) {
            this.$router.push("/resales");
          } else {
            this.$router.push("/auth");
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log('err')
          console.log(err)
          console.log('err')
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: err.body ? err.body.message : messageError,
            trace: null,
          });
          this.loading = false;
        });
    },

    async sendEmailResale(email) {
      await this.apiService
        .post("email/sendClient", email)
        .then((resp) => {
          if (this.isEditing) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "info",
              title: "Cadastro atualizado com sucesso!",
              message: "Seus dados foram atualizados",
              trace: null,
            });
          } else {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Cadastro efetuado com sucesso!",
              message: "Bem vindo à IMPRIMAX!",
              trace: null,
            });
          }
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: "E-mail inválido",
            trace: null,
          });

          this.loading = false;
        });
    },

    async validate() {
      this.loading = true;

      const userValid = {
        Cnpj: this.currentResale.cnpj,
        Email: this.currentResale.email,
        Name: this.currentResale.name,
        PhoneNumber: this.currentResale.phoneNumber,
        PhoneNumber2: this.currentResale.phoneNumber2,
      };

      await this.apiService
        .post("resale/validate", userValid)
        .then(() => {
          if (this.step == 3) {
            this.submit();
            this.sucessDialog = true;
          } else if (this.step != 3) {
            this.step += 1;
          }
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: err.body.message,
            message: err.body.message,
            trace: null,
          });

          this.loading = false;
        });
    },
  },
};
</script>
